export const GET = {
  REQUEST: 'Parties/Get/Request',
  SUCCESS: 'Parties/Get/Success',
  FAILURE: 'Parties/Get/Failure'
};

export const FORSUBMIT = {
  REQUEST: 'Parties/ForSubmit/Request',
  SUCCESS: 'Parties/ForSubmit/Success',
  FAILURE: 'Parties/ForSubmit/Failure'
};

export const UNITS = {
  REQUEST: 'Parties/Units/Request',
  SUCCESS: 'Parties/Units/Success',
  FAILURE: 'Parties/Units/Failure'
};

export const UNITS_CURRENT = {
  REQUEST: 'Parties/Units/Current/Request',
  SUCCESS: 'Parties/Units/Current/Success',
  FAILURE: 'Parties/Units/Current/Failure'
};

export const CREATE = {
  REQUEST: 'Parties/Create/Request',
  SUCCESS: 'Parties/Create/Success',
  FAILURE: 'Parties/Create/Failure'
};

export const UPDATE = {
  REQUEST: 'Parties/Update/Request',
  SUCCESS: 'Parties/Update/Success',
  FAILURE: 'Parties/Update/Failure'
};

export const DELETE = {
  REQUEST: 'Parties/Delete/Request',
  SUCCESS: 'Parties/Delete/Success',
  FAILURE: 'Parties/Delete/Failure'
};

export const CURRENT = {
  REQUEST: 'Parties/Current/Request',
  SUCCESS: 'Parties/Current/Success',
  FAILURE: 'Parties/Current/Failure'
};

export const GET_PARTY_EXERCISES = {
  REQUEST: 'Parties/GetPartyExercises/Request',
  SUCCESS: 'Parties/GetPartyExercises/Success',
  FAILURE: 'Parties/GetPartyExercises/Failure'
};
